import type { SneakPeekQueryRow } from '@/services/api/sneakPeek'

function germanDate(iso: string) {
  const [year, month, day] = iso.slice(0, 10).split('-')
  return `${day}.${month}.${year}`
}

function rangeLabel(from: string, to: string) {
  if (from === to) return germanDate(from)
  return `${germanDate(from)} – ${germanDate(to)}`
}

function savedLabel(iso: string) {
  const date = new Date(iso)
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${pad(date.getUTCDate())}.${pad(date.getUTCMonth() + 1)}.${date.getUTCFullYear()} ${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}`
}

export function SavedQueries({
  queries,
  onOpen,
  onOpenVersion,
  onDelete,
  onDeleteVersion,
}: {
  queries: SneakPeekQueryRow[]
  onOpen: (id: string) => void
  onOpenVersion: (queryId: string, versionId: string) => void
  onDelete: (id: string) => void
  onDeleteVersion: (queryId: string, versionId: string) => void
}) {
  return (
    <section aria-label="Abfragen" className="mb-4">
      {queries.map((row) => (
        <article key={row.id} aria-label={`Abfrage ${row.absent}`} className="mb-2 rounded-lg border bg-white">
          <button
            type="button"
            className="flex w-full flex-wrap gap-x-4 gap-y-1 px-4 py-3 text-left text-sm"
            onClick={() => onOpen(row.id)}
          >
            <span>{row.absent}</span>
            <span>{rangeLabel(row.date_from, row.date_to)}</span>
            <span>{savedLabel(row.saved_at)}</span>
            <span>{row.original_admin}</span>
          </button>
          {(row.versions ?? []).map((version) => (
            <div key={version.id} className="flex flex-wrap items-center gap-3 border-t px-4 py-2 text-sm">
              <button type="button" onClick={() => onOpenVersion(row.id, version.id)}>
                <span>{savedLabel(version.saved_at)}</span>
                <span>{version.admin}</span>
              </button>
              {version.can_delete && (
                <button type="button" onClick={() => onDeleteVersion(row.id, version.id)}>
                  Version löschen
                </button>
              )}
            </div>
          ))}
          {row.can_delete && (
            <button
              type="button"
              className="border-t px-4 py-2 text-left text-sm"
              onClick={() => onDelete(row.id)}
            >
              Abfrage löschen
            </button>
          )}
        </article>
      ))}
    </section>
  )
}
